import { ReferralsPortalProfileUpdate } from './profile.interfaces';

export class LoadReferralsProfile {
  public static type: string = '[HTTP] LoadReferralsProfile';
  constructor(public payload?: { active?: boolean }) {}
}

export class UpdateReferralsProfile {
  public static type: string = '[HTTP] UpdateReferralsProfile';
  constructor(public payload: ReferralsPortalProfileUpdate) {}
}
